var exports = {
  "DD": "xdbfd91f1--9a5028--title",
  "N4": "xdbfd91f1--9a5028--feature",
  "h_": "xdbfd91f1--9a5028--description",
  "Sl": "xdbfd91f1--9a5028--image",
  "Rg": "xdbfd91f1--9a5028--image--default",
};

module.exports = exports;
